import Insights from '@migrate/components/insights/Insights'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

// This is still used in an iframe in ILM, yes we iframe ILM to then re-iframe portal...
export const Route = createFileRoute('/_auth/embedded/dashboard/admin/powerbi/$reportId')({
  component: RouteComponent,
  params: z.object({
    reportId: z.string(),
  }),
})

function RouteComponent() {
  const { reportId } = Route.useParams()
  return <Insights reportId={reportId} viewMode="edit" />
}
